// 在main.js上通过import引入Vue库和自己写的Vue组件库
import Vue from 'vue';
import homepage from './components/homepage.vue';

(function (KDApi) {
    function AttCalendar(model) {
        this._setModel(model)
    }

    AttCalendar.prototype = {
        _setModel: function (model) {
            this.model = model
        },
        init: function (props) {
            this.uniqueId = new Date().getTime();
            this.themeNum = props.themeNum;
        },
        update: function (props) {
            let $this = this;

            if (props.data && props.data.event === 'init') {
                $this.homepage_vue ? $this.homepage_vue.$data.month = props.data.args : this.setHtml(this.model, props);
            }

            if (props.data && props.data.event === 'dateData') {
                $this.homepage_vue.updateChooseDate(props.data.args);
            }
        },
        destoryed: function(){
            // alert('日历控件销毁')
        },

        setHtml(model, props) {
            let $this = this;

            KDApi.loadFile(['./css/index.css', './js/myTool.js'], model, () => {
                $this.homepage_vue = new Vue({
                    el: model.dom,
                    template: `<div>
                        <homepage ref="homepage" :calendarType="calendarType" :currentMonth="currentMonth" :earliestMonth="earliestMonth"
                                  :maxChoose="maxChoose" :dateList="dateList" :model="model" :KDApi="KDApi"></homepage>
                    </div>`,
                    components: {
                        homepage
                    },
                    data: {
                        model: $this.model,
                        calendarType: props.data.args.calendarType ? props.data.args.calendarType : "SEPARATE",   // 日期使用类型，多选日期-choose 日期范围-range
                        currentMonth: props.data.args.currentMonth,
                        earliestMonth: props.data.args.earliestMonth ? props.data.args.earliestMonth : "1900-01",
                        maxChoose: props.data.args.maxChoose ? props.data.args.maxChoose : 0,
                        dateList:props.data.args.dateList,
                        KDApi: KDApi,
                    },
                    mounted() {
                        this.myTool = new window.KdWtcMyTool();
                        this.$root.$el.style.setProperty('--themeColor', $this.themeNum);
                    },
                    methods: {
                        updateChooseDate: function (dateList) {
                            this.$refs.homepage.updateChooseDate(dateList);
                        },
                    }
                })
            })
        }
    };

    // 注册自定义组件
    KDApi.register('calendarchoose', AttCalendar, {isMulLang: true})
})(window.KDApi);
